export default "__VITE_ASSET__BJTZ1k0r__"